import {
  Card,
  CardHeader,
  CardContent,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  IconButton,
  TableHead,
  TableBody,
  Typography,
  Collapse,
  Box,
  TablePagination,
  TextField,
  InputAdornment,
  Dialog,
  DialogContent,
  // DialogTitle,
  Divider,
  // Grid,
  Button,
} from "@material-ui/core";
import {
  ArrowForward,
  Search,
  Check as CheckIcon,
  Clear as ClearIcon,
} from "@material-ui/icons";
import axios from "axios";
import React, { Fragment, useEffect } from "react";
import { useContext } from "react";
import { useState } from "react";
import { ArrowUp, Edit } from "react-feather";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";

const LabOrderTest = ({ labOrderList, getLaboratoryOrderList }) => {
  const { users } = useContext(UsersData);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [listItem, setListItem] = useState({ data: [], ready: false });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openEditMobileRate, setOpenEditMobileRate] = useState({
    open: false,
    data: [],
  });

  const handleSelectedOrder = async (data) => {
    if (selectedOrder) {
      if (selectedOrder.order_id === data.order_id) {
        console.log("id is currently selected");
        return;
      }
    }

    let response = await axios.get(
      "accounting/items/laborder/list-available-items",
      {
        params: {
          user_id: users.user_id,
          management_id: users.management_id,
          order_id: data.order_id,
        },
      }
    );
    setSelectedOrder(data);
    setListItem({ data: response.data, ready: true });
  };

  const handleUpdateMRatePurpose = (data) => {
    setOpenEditMobileRate({ open: true, data });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    event.persist();
    setPage(newPage);
  };

  const handleGetUpdateNewRates = (e) => {
    e.preventDefault();
    e.persist();
    var formdata = new FormData(e.target);
    formdata.append("user_id", users.user_id);
    formdata.append("management_id", users.management_id);
    formdata.append("main_mgmt_id", users.main_mgmt_id);
    axios
      .post("accounting/update/laboratory-rates", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          getLaboratoryOrderList();
          setOpenEditMobileRate({ open: false, data: [] });
          Notify.successRequest("update laboratory rate");
        }
      })
      .catch((error) => {
        Notify.requestError(error);
      });
  };

  useEffect(() => {}, [labOrderList]);

  const searchable = labOrderList.data.filter((data) => {
    return (
      data.laborder.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1
    );
  });

  return (
    <Card>
      <CardHeader
        title={
          <Box display="flex">
            <Box flexGrow={1}>
              <Typography variant="h6">Laboratory Order List</Typography>
            </Box>
            <Box>
              <TextField
                label="Search Lab Order"
                variant="outlined"
                fullWidth
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        }
      />
      <CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell> Category </TableCell>
                <TableCell> Lab Order </TableCell>
                <TableCell align="center"> Clinic rate </TableCell>
                <TableCell align="center"> Mobile rate </TableCell>
                <TableCell align="center"> Action </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {labOrderList.ready ? (
                searchable.length > 0 ? (
                  searchable
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data, index) => {
                      return (
                        <Fragment key={index}>
                          <TableRow>
                            <TableCell> {data.category}</TableCell>
                            <TableCell> {data.laborder}</TableCell>
                            <TableCell align="right">
                              {Notify.convertToNumber(data.rate)}
                            </TableCell>
                            <TableCell align="right">
                              {data.mobile_rate !== null
                                ? Notify.convertToNumber(data.mobile_rate)
                                : ""}
                            </TableCell>
                            <TableCell align="center">
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                              >
                                <Box>
                                  <IconButton
                                    color="primary"
                                    onClick={() => handleSelectedOrder(data)}
                                    disabled={
                                      selectedOrder &&
                                      selectedOrder.order_id === data.order_id
                                    }
                                  >
                                    {selectedOrder &&
                                    selectedOrder.order_id === data.order_id ? (
                                      <ArrowUp />
                                    ) : (
                                      <ArrowForward />
                                    )}
                                  </IconButton>
                                </Box>
                                <Box>
                                  <IconButton
                                    color="primary"
                                    onClick={() =>
                                      handleUpdateMRatePurpose(data)
                                    }
                                  >
                                    <Edit />
                                  </IconButton>
                                </Box>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              style={{ paddingBottom: 0, paddingTop: 0 }}
                              colSpan={6}
                            >
                              {selectedOrder && (
                                <Collapse
                                  in={data.order_id === selectedOrder.order_id}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Box margin={1}>
                                    <Typography
                                      variant="h6"
                                      gutterBottom
                                      component="div"
                                    >
                                      Item List
                                    </Typography>

                                    <Box>
                                      <Table size="small">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell>
                                              <b> Brand </b>
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                maxWidth: 250,
                                              }}
                                            >
                                              <b> Description </b>
                                            </TableCell>
                                            <TableCell>
                                              <b> Supplier </b>
                                            </TableCell>
                                            <TableCell>
                                              <b> Qty </b>
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {listItem.ready ? (
                                            listItem.data.length > 0 ? (
                                              listItem.data.map(
                                                (datax, xindex) => (
                                                  <TableRow key={xindex}>
                                                    <TableCell>
                                                      {datax.item}
                                                    </TableCell>
                                                    <TableCell>
                                                      {datax.description}
                                                    </TableCell>
                                                    <TableCell>
                                                      {datax.supplier}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                      {
                                                        datax._total_qty_available
                                                      }
                                                    </TableCell>
                                                  </TableRow>
                                                )
                                              )
                                            ) : (
                                              <TableRow>
                                                <TableCell colSpan={5}>
                                                  <Typography color="secondary">
                                                    No record found.
                                                  </Typography>
                                                </TableCell>
                                              </TableRow>
                                            )
                                          ) : (
                                            <TableRow>
                                              <TableCell colSpan={5}>
                                                <Typography color="primary">
                                                  loading, please wait...
                                                </Typography>
                                              </TableCell>
                                            </TableRow>
                                          )}
                                        </TableBody>
                                      </Table>
                                    </Box>
                                  </Box>
                                </Collapse>
                              )}
                            </TableCell>
                          </TableRow>
                        </Fragment>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={4}>
                      <Typography color="secondary">
                        No record found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={4}>
                    <Typography color="primary">
                      Loading, Please wait...
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={searchable.length}
            rowsPerPageOptions={[
              5,
              10,
              20,
              { value: searchable.length, label: "All" },
            ]}
            page={page}
            onChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage="List"
          />
        </TableContainer>
      </CardContent>
      <Dialog
        open={openEditMobileRate.open}
        onClose={() => setOpenEditMobileRate({ open: false, data: [] })}
      >
        <Box m={2}>
          <Typography variant="h5">Edit Mobile Rate</Typography>
        </Box>
        <DialogContent dividers>
          <form onSubmit={handleGetUpdateNewRates}>
            {openEditMobileRate.open && (
              <>
                <Box mb={2}>
                  <Box className={`labselect2`} mb={2}>
                    <TextField
                      select
                      label="Order can be discounted?"
                      SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      name="can_be_discounted"
                      defaultValue={
                        openEditMobileRate.data.rate !== null
                          ? openEditMobileRate.data.can_be_discounted
                          : ""
                      }
                      required
                    >
                      <option value=""> Select </option>
                      <option value={1}> Yes </option>
                      <option value={0}> No </option>
                    </TextField>
                  </Box>

                  <Box className={`labselect2`} mb={2}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={openEditMobileRate.data.order_id}
                      name="order_id"
                      hidden
                    />

                    <TextField
                      fullWidth
                      required
                      name="rate"
                      label="Laboratory Rate"
                      variant="outlined"
                      type="number"
                      defaultValue={
                        openEditMobileRate.data.rate !== null
                          ? openEditMobileRate.data.rate
                          : ""
                      }
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: 10000,
                          step: 0.01,
                        },
                      }}
                    />
                  </Box>

                  <Box className={`labselect2`}>
                    <TextField
                      fullWidth
                      required
                      name="mobile_rate"
                      label="Mobile Rate"
                      variant="outlined"
                      type="number"
                      defaultValue={
                        openEditMobileRate.data.mobile_rate !== null
                          ? openEditMobileRate.data.mobile_rate
                          : openEditMobileRate.data.rate
                      }
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: 10000,
                          step: 0.01,
                        },
                      }}
                    />
                  </Box>

                  <Divider />
                  <Box my={2} display="flex">
                    <Box flexGrow={1} />

                    <Button
                      variant="contained"
                      color="default"
                      startIcon={<ClearIcon />}
                      onClick={() =>
                        setOpenEditMobileRate({ open: false, data: [] })
                      }
                    >
                      Close
                    </Button>

                    <Box ml={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        startIcon={<CheckIcon />}
                        // disabled={isSubmitting}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </form>
        </DialogContent>
      </Dialog>
    </Card>
  );
};

export default LabOrderTest;
